import { render, staticRenderFns } from "./AtualizarSenha.vue?vue&type=template&id=587ae58a"
import script from "./AtualizarSenha.vue?vue&type=script&lang=js"
export * from "./AtualizarSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports